jQuery( ".drawer:not(.locked)" ).click(function() {
	
 jQuery( '.selected' ).removeClass('selected');
 jQuery( '.gallery' ).removeClass('opened');
 jQuery( '.drawer' ).css('width', '3rem');
	
  jQuery( this ).addClass('selected');
  jQuery('.gallery').addClass('opened');
  
  var drawer_total = jQuery( this ).data( "total" );
  
  var drawer_width = 48 * drawer_total;
  
  var css = "calc(100% - " + drawer_width + "px)";
  
   jQuery( '.selected' ).css('width', css);
  
  jQuery( this ).children('.designer-gallery').slick('setPosition');
  
});


jQuery(document).on('click','.close',function(){
	
	 jQuery( '.selected' ).removeClass('selected');
	 jQuery( '.gallery' ).removeClass('opened');
	  jQuery( '.drawer' ).css('width', '3rem');
	 
});


jQuery( ".headshot" ).click(function() {
	
	jQuery( '.selected' ).removeClass('selected');
	jQuery( '.gallery' ).removeClass('opened');
	jQuery( '.drawer' ).css('width', '3rem');
	
});